import request from './request'
import Vue from 'vue'

export const authState = Vue.observable({ user: null })
let loadingUser = null
let userRequest = 0

export async function getCurrentUser(force = false) {
  if (!force && authState.user) return authState.user
  if (!force && loadingUser) return loadingUser
  const requestId = ++userRequest
  loadingUser = request.get('/webserver/auth/me')
    .then(response => {
      if (requestId === userRequest) authState.user = response.data
      return response.data
    })
    .finally(() => { if (requestId === userRequest) loadingUser = null })
  return loadingUser
}

export async function login(username, password) {
  await request.post('/webserver/auth/login', { username, password })
  clearCurrentUser()
  return getCurrentUser(true)
}

export async function logout() {
  try {
    await request.post('/webserver/auth/logout')
  } finally {
    clearCurrentUser()
  }
}

export function clearCurrentUser() {
  userRequest++
  authState.user = null
  loadingUser = null
}

export function hasPermission(permission, user = authState.user) {
  if (!user) return false
  if (user.superAdmin) return true
  const required = Array.isArray(permission) ? permission : [permission]
  return required.some(value => (user.permissions || []).includes(value))
}
